import { jsx, jsxs } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { RenderIfVisible } from '@fabric-app/ui/components/RenderIfVisible/RenderIfVisible';
import PagePlaceholder from './PagePlaceholder.js';
import { usePDFContent } from './PDF.js';
import { styled } from 'styled-components';
import useDeferred from '@fabric-app/hooks/useDeferred';
import Skeleton from '@fabric-app/ui/components/Skeleton';

const Wrapper = styled.div.withConfig({
  displayName: "TinyPage__Wrapper",
  componentId: "sc-23bdbadb-0"
})([
  `display:flex;flex-direction:column;gap:8px;color:white;align-items:center;position:relative;> span{font-weight:600;font-size:12px;line-height:15px;}`
]);
const Page = styled.div.withConfig({
  displayName: "TinyPage__Page",
  componentId: "sc-23bdbadb-1"
})([
  `cursor:pointer;border:4px solid transparent;border-radius:10px;box-sizing:border-box;overflow:hidden;> *{border-radius:4px;overflow:hidden;}&[data-active='true']{border-color:#93b3f2;}`
]);
const TinyPage = ({ pageNumber, width, style, root, onClick = () => {
} }) => {
  const { getEstimatedHeight, currentPage } = usePDFContent();
  const active = useMemo(() => pageNumber === currentPage, [
    pageNumber,
    currentPage
  ]);
  const height = useMemo(() => getEstimatedHeight(pageNumber, width, true), [
    getEstimatedHeight,
    pageNumber,
    width
  ]);
  const deferredRoot = useDeferred(root);
  return /* @__PURE__ */ jsx("div", {
    "aria-current": active,
    "aria-label": `Page ${pageNumber}`,
    role: "button",
    "data-page": pageNumber,
    children: /* @__PURE__ */ jsxs(Wrapper, {
      style: {
        ...style
      },
      children: [
        root === deferredRoot ? /* @__PURE__ */ jsx(RenderIfVisible, {
          defaultHeight: height,
          visibleOffset: height * 10,
          root: deferredRoot,
          initialVisible: pageNumber < 8,
          placeholderElement: "div",
          // Make it so 3 pages after and before the currentPage are always rendered
          stayRendered: pageNumber > currentPage - 3 && pageNumber < currentPage + 3,
          children: /* @__PURE__ */ jsx(Page, {
            onClick,
            "data-active": active,
            style: {
              width,
              height
            },
            children: /* @__PURE__ */ jsx(PagePlaceholder, {
              pageNumber,
              smallSpinner: true,
              size: "small"
            })
          })
        }, pageNumber) : /* @__PURE__ */ jsx("div", {
          style: {
            border: "4px solid transparent",
            width,
            height
          },
          children: /* @__PURE__ */ jsx(Skeleton, {
            borderRadius: 10,
            style: {
              width: "100%",
              height: "100%",
              display: "flex"
            }
          })
        }),
        /* @__PURE__ */ jsx("span", {
          children: pageNumber
        })
      ]
    })
  });
};

export { TinyPage as default };
//# sourceMappingURL=TinyPage.js.map
